import { BlogContent } from "../blog/blog";
import { ViewCounter } from "../../common/view-counter/view-counter";
import MenuPage from "../menu-page/menu-page";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";
import { usePremium } from "../auth/is_loggedin";
import AvatarProfile from "../../common/avatar-profile/avatar-profile";
import LinkButton from "../link-button/link-button";
import { config } from "../../../config";
import { useSmartNavigate } from "../../../hooks/useSmartNavigate";
import MenuLink from "@/components/menu-link";
import Notice from "../notice";
import Maintenance from "../maintenance";
import { FeatureGate } from "@/components/common/feature-gate";

const Main = () => {
  const navigate = useSmartNavigate();
  const { t } = useTranslation("main");

  const premium = usePremium();

  let selectConfig = useAppSelector((state) => state.meta.config);

  let selectPlayerDetails = useAppSelector((state) => state.menu.playerDetails);

  function handleStart() {
    if (selectPlayerDetails && selectPlayerDetails.name.length > 0) {
      navigate("/play");
    } else {
      navigate("/user/setup");
    }
  }

  function footer() {
    return (
      <div className={"flex flex-1 flex-row items-center justify-between"}>
        <div className={"ml-1 flex items-center justify-center space-x-1"}>
          <a
            href="https://discord.gg/xE4rrQkHRn"
            target="_blank"
            rel="noreferrer"
            className="text-blue-900 hover:text-blue-950 underline"
          >
            discord
          </a>
          <span>|</span>
          <a
            href="https://bsky.app/profile/franticfanfic.com"
            target="_blank"
            rel="noreferrer"
            className="text-blue-900 hover:text-blue-950 underline"
          >
            bluesky
          </a>
          <span>|</span>

          <a
            href="https://www.tiktok.com/@franticfanfic"
            target="_blank"
            rel="noreferrer"
            className="text-blue-900 hover:text-blue-950 underline"
          >
            tiktok
          </a>
          <span>|</span>

          <a
            href="https://www.instagram.com/franticfanfic"
            target="_blank"
            rel="noreferrer"
            className="text-blue-900 hover:text-blue-950 underline"
          >
            instagram
          </a>
        </div>
        <ViewCounter />
      </div>
    );
  }

  return (
    <MenuPage
      hideAvatar
      disableBack
      subHeaders={[t("subheaders.default")]}
      titles={[t("headers.default")]}
      footerJsx={footer()}
    >
      <div className={"relative flex flex-col items-stretch"}>
        {selectConfig?.notice_message && (
          <Notice noticeMessage={selectConfig.notice_message} />
        )}
        {selectConfig?.maintenance && (
          <Maintenance maintenanceMessage={selectConfig.maintenance_message} />
        )}

        <div className={"flex-shrink-0"}>{<AvatarProfile />}</div>
        <div
          className={
            "relative flex flex-shrink-0 flex-col items-stretch space-y-4 self-center"
          }
        >
          <LinkButton path={"/user"} size={"4xl"}>
            {selectPlayerDetails && selectPlayerDetails?.name.length > 0
              ? t("body.editName")
              : t("body.name")}
          </LinkButton>

          <LinkButton
            path={"/play"}
            size={"4xl"}
            disabled={
              selectConfig?.maintenance &&
              localStorage.getItem("testing") === null &&
              !config.isDevelopment
            }
          >
            {t("body.start")}
          </LinkButton>

          <LinkButton path={"/supporter"} size={"4xl"}>
            {premium ? t("body.auth2") : t("body.auth")}
          </LinkButton>

          <LinkButton path={"/howtoplay"} size={"4xl"}>
            {t("body.help")}
          </LinkButton>

          <LinkButton path={"/bugreport"} size={"4xl"}>
            report a bug
          </LinkButton>
        </div>

        <div className={"relative mt-16 pt-8"}>
          <div
            className={
              "p-2 [&_h2]:font-extrabold [&_h3]:font-bold [&_h4]:font-semibold [&_p]:normal-case [&_li]:ml-2 [&_li]:normal-case"
            }
          >
            <BlogContent />
          </div>
        </div>
        <div className={"relative flex-shrink-0 self-center"}>
          <MenuLink path={"/terms"}> {t("body.terms")}</MenuLink>
          <MenuLink path={"/privacy"}> {t("body.privacy")}</MenuLink>
          <MenuLink path={"/codeofconduct"}>{t("body.codeOfConduct")}</MenuLink>
          <MenuLink path={"/contact"}> {t("body.contact")}</MenuLink>
          <MenuLink path={"/about"}> {t("body.about")}</MenuLink>
        </div>
      </div>
    </MenuPage>
  );
};

export default Main;
